if (!customElements.get('misc-content')) {
  class MiscContent extends HTMLElement {
    constructor() {
      super();
      this.videos = this.querySelectorAll('.js-misc-content-video');
      this.init();
    }

    init() {
      const observer = new IntersectionObserver(this.handleIntersection.bind(this), { root: null, rootMargin: '0px' });
      observer.observe(this);
    }

    handleIntersection(entries) {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.playVideos();
        } else {
          this.pauseVideos();
        }
      });
    }

    playVideos() {
      this.videos.forEach((video) => {
        video.play();
      });
    }

    pauseVideos() {
      this.videos.forEach((video) => {
        video.pause();
      });
    }
  }

  customElements.define('misc-content', MiscContent);
}
